/* Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import { createTimelyAlert } from 'state/timelyAlert/TimelyAlertActions';
import Content from 'services/Content';

/**
 * Use createTimelyAlert for creating a new one.
 */

export const PAGES = {
  DASHBOARD: '/dashboard',
  STATEMENTS: '/statements',
  MESSAGE_CENTER: '/message-center'
};

export const TIMELY_ALERTS = [
  createTimelyAlert(Content.statementsTimelyAlertText, PAGES.STATEMENTS),
  createTimelyAlert(Content.messageCenterTimelyAlertText, PAGES.MESSAGE_CENTER)
];
